export default __webpack_public_path__ + "static/media/misc-pantry1-480w.d1cb71b0.png";